module.exports = __webpack_public_path__ + "img/49_17.ef6d55a5.png";